/**
 * 日期计算&处理工具类
 */
import { commonUtil, dateUtil } from '@qnpm/q-design-utils';
const WEEK_DAYS = [
    ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    ['日', '一', '二', '三', '四', '五', '六']
];
/* ------- 📅日历数据计算逻辑 start ------- */
/**
 * 计算日期列表
 * @param param
 *  - year：年份
 *  - month：月份
 *  - start：开始周次
 *  - blankOut：不在本月的日期不展示
 */
export function generatorDateList(param) {
    try {
        const { year, month, start = 0, blankOut = false, serviceTime = new Date(), extraDayContent } = param;
        // 计算时的月份
        const calcMonth = month - 1;
        // 当前月第一天
        const currentDate = new Date(year, calcMonth);
        // 当前月的最后一天（这里利用Date的对传入参数为0时的自动调整逻辑，来获取当前月的最后一天）
        const currentMonthEndDay = new Date(year, calcMonth + 1, 0);
        // 上月的最后一天
        const lastMonthEndDay = new Date(year, calcMonth, 0);
        // 当前月第一天是星期几
        const currentFirstDayWeek = currentDate.getDay();
        // 当月的最后一天是星期几
        const currentLastDayWeek = currentMonthEndDay.getDay();
        // 当前月最后一天的日期
        const currentMonthEndDate = currentMonthEndDay.getDate();
        // 上月最后一天的日期
        const lastMonthEndDate = lastMonthEndDay.getDate();
        // 上月在本月出现的天数
        const lastMonthDay = start <= currentFirstDayWeek
            ? currentFirstDayWeek - start
            : 7 - start + currentFirstDayWeek;
        // 下月出现在本月的天数
        const nextMonthDay = start <= currentLastDayWeek
            ? 6 - currentLastDayWeek + start
            : start - currentLastDayWeek - 1;
        // 日期列表
        const dateList = [];
        // 计算上月出现在本月中的日期
        for (let i = 0; i < lastMonthDay; i++) {
            const tempYear = calcMonth > 0 ? year : year - 1;
            const tempMonth = calcMonth > 0 ? calcMonth : 12;
            dateList.unshift(Object.assign(Object.assign({}, computeDateStr({
                year: tempYear,
                month: tempMonth,
                date: lastMonthEndDate - i,
                blankOut,
                serviceTime,
                extraDayContent
            })), { position: 'previous' }));
        }
        // 填充当月日期
        for (let i = 1; i < currentMonthEndDate + 1; i++) {
            dateList.push(Object.assign(Object.assign({}, computeDateStr({
                year,
                month: calcMonth + 1,
                date: i,
                blankOut: false,
                serviceTime,
                extraDayContent
            })), { position: 'current' }));
        }
        // 计算下月出现在当前月中的日期
        for (let i = 1; i <= nextMonthDay; i++) {
            const tempYear = calcMonth + 2 < 13 ? year : year + 1;
            const tempMonth = calcMonth + 2 < 13 ? calcMonth + 2 : 1;
            dateList.push(Object.assign(Object.assign({}, computeDateStr({
                year: tempYear,
                month: tempMonth,
                date: i,
                blankOut,
                serviceTime,
                extraDayContent
            })), { position: 'next' }));
        }
        // 展示的行数
        const line = Math.ceil(dateList.length / 7);
        return {
            dateList,
            line,
            month
        };
    }
    catch (e) {
        // eslint-disable-next-line no-console
        console.warn('generatorDateList error:', e);
        return { dateList: [], line: 0, month: 0 };
    }
}
/**
 * 拼接日期信息
 * @param year
 * @param month
 * @param date
 * @param blankOut
 * @param serviceTime
 * @param extraDayContent
 */
export function computeDateStr({ year, month, date, blankOut, serviceTime, extraDayContent }) {
    const tempMonth = month < 10 ? `0${month}` : month;
    const tempDate = date < 10 ? `0${date}` : date;
    const key = `${year}/${month}/${date}`;
    if (blankOut) {
        return {
            value: '',
            zhStr: '',
            year: '',
            month: '',
            date: '',
            showValue: '',
            key
        };
    }
    const value = `${year}-${tempMonth}-${tempDate}`;
    return {
        value,
        zhStr: `${year}年${month}月${date}日`,
        year,
        month,
        date,
        showValue: computeShowValue(value, date, serviceTime, extraDayContent),
        key
    };
}
/**
 * 计算展示文案
 * @param defaultValue
 * @param serviceTime
 * @param value
 * @param extraDayContent
 */
function computeShowValue(value, defaultValue, serviceTime, extraDayContent) {
    try {
        // 如果配置为空，则直接返回空
        if (!commonUtil.isValidArray(extraDayContent)) {
            return defaultValue;
        }
        // 计算与当前时间的间隔
        const distanceDay = dateUtil.distanceTime(serviceTime, value);
        // 如果间隔天数超过配置数组长度，则使用默认值
        const isOut = distanceDay > extraDayContent.length - 1;
        return isOut ? defaultValue : extraDayContent[distanceDay];
    }
    catch (e) {
        // eslint-disable-next-line no-console
        console.warn('computeShowValue error:', e);
        return defaultValue;
    }
}
/**
 * @name convertDyadicArray 一维数组转换为二维数组
 * @param param
 * @example convertDyadicArray([2,3,4,5,6,7], 3) => [[2,3],[4,5],[6,7]]
 */
export function convertDyadicArray(param) {
    const { dateList, line } = param;
    const dyadicArray = [];
    const col = dateList.length / line;
    for (let i = 0; i < line; i++) {
        dyadicArray.push(dateList.slice(i * col, (i + 1) * col));
    }
    return dyadicArray;
}
/* ------- 📅日历数据计算逻辑 end ------- */
/**
 * 生成指定年的指定月份的日历
 * @param year 年份
 * @param startMonth 开始月份
 * @param endMonth 结束月份
 * @param start 开始周次
 * @param blankOut 上下月日期是否空白
 * @param serviceTime
 * @param extraDayContent
 */
export function generatorCalendar({ year, startMonth = 0, endMonth = 12, start, blankOut, serviceTime, extraDayContent }) {
    if (!validMonth(startMonth) ||
        !validMonth(endMonth) ||
        startMonth > endMonth) {
        // eslint-disable-next-line no-console
        console.warn('传入的月份有误，请检查');
        return [];
    }
    try {
        const calendars = [];
        for (let i = startMonth; i <= endMonth; i++) {
            const dayList = generatorDateList({
                year,
                month: i,
                start,
                blankOut,
                serviceTime,
                extraDayContent
            });
            const weekList = convertDyadicArray(dayList);
            const kMonth = i < 10 ? `0${i}` : i;
            calendars.push({
                index: i - startMonth,
                title: `${year}年${i}月`,
                monthKey: `${year}-${kMonth}-01`,
                weekList,
                year,
                month: i
            });
        }
        return calendars;
    }
    catch (e) {
        // eslint-disable-next-line no-console
        console.warn('generatorCalendar error:', e);
        return [];
    }
}
/**
 * 计算某个范围内的日历
 * @param minDate
 * @param maxDate
 * @param start
 * @param blankOut
 * @param serviceTime
 * @param extraDayContent
 */
export function generatorRangeCalendar({ minDate, maxDate, start, blankOut, serviceTime, extraDayContent }) {
    // 如果最小日期大于最大日期，则终止操作
    if (dateUtil.compareDateWithDay(maxDate, minDate)) {
        return [];
    }
    const rangYears = computeRangeYear(minDate, maxDate);
    let rangDateList = [];
    // 遍历生成范围日历
    rangYears.forEach((item) => {
        const result = generatorCalendar({
            year: item.year,
            startMonth: item.startMonth,
            endMonth: item.endMonth,
            start,
            blankOut,
            serviceTime,
            extraDayContent
        });
        rangDateList = rangDateList.concat(result);
    });
    return rangDateList;
}
/**
 * 计算某个范围内的年份数据
 * @param minDate
 * @param maxDate
 */
function computeRangeYear(minDate, maxDate) {
    try {
        // 转换日期
        const minDateInfo = parseDateInfo(minDate);
        const maxDateInfo = parseDateInfo(maxDate);
        // 如果最大最小日期在同一年
        if (minDateInfo.year === maxDateInfo.year) {
            return [
                {
                    year: minDateInfo.year,
                    startMonth: minDateInfo.month,
                    endMonth: maxDateInfo.month
                }
            ];
        }
        const years = [
            {
                year: minDateInfo.year,
                startMonth: minDateInfo.month,
                endMonth: 12
            }
        ];
        for (let i = minDateInfo.year + 1; i < maxDateInfo.year; i++) {
            years.push({
                year: i,
                startMonth: 1,
                endMonth: 12
            });
        }
        years.push({
            year: maxDateInfo.year,
            startMonth: 1,
            endMonth: maxDateInfo.month
        });
        return years;
    }
    catch (e) {
        // eslint-disable-next-line no-console
        console.warn('computeRangeYear error:', e);
        return [];
    }
}
/**
 * 解析传入的日期
 * @param date
 */
export function parseDateInfo(date) {
    // 校验日期，如果日期为空或者不合格，则使用当前日期
    let nextDate = dateUtil.toDate(date, new Date());
    return {
        year: nextDate.getFullYear(),
        month: nextDate.getMonth() + 1,
        date: nextDate.getDate()
    };
}
/**
 * 校验月份
 * @param month
 */
function validMonth(month) {
    return !(month <= 0 || month > 12);
}
/**
 * 获取默认选中日期
 */
export function getDefaultDateInfo(date) {
    const { year, month, date: cDate } = parseDateInfo(date);
    return Object.assign(Object.assign({}, computeDateStr({ year, month, date: cDate, blankOut: false })), { position: 'current' });
}
/**
 * 计算顶部周名称
 * @param type
 * @param start
 */
export function generatorWeekHeader(type = 1, start = 0) {
    const weekdays = WEEK_DAYS[type];
    const after = weekdays.slice(0, start);
    const before = weekdays.slice(start);
    return before.concat(after);
}
